module.exports = __webpack_public_path__ + "img/landscape_mobile.5bf89c29.png";